import { type Static, Type } from '@sinclair/typebox';
import { ChannelDTOSchema } from '../dto/channel.dto.js';
import { MongoIdStringSchema } from '../dto/common.dto.js';
import { TierDTOSchema } from '../dto/tier.dto.js';

// =====================================================================================================================
// Create Tier
// =====================================================================================================================

export const CreateTierBodySchema = Type.Composite([
  Type.Pick(TierDTOSchema, ['benefits', 'description', 'title', 'amount', 'state']),
  Type.Object({
    channelId: MongoIdStringSchema,
  }),
]);
export type CreateTierBody = Static<typeof CreateTierBodySchema>;

export const CreateTierReplySchema = ChannelDTOSchema;
export type CreateTierReply = Static<typeof CreateTierReplySchema>;

// =====================================================================================================================
// Delete Tier
// =====================================================================================================================

export const DeleteTierBodySchema = Type.Object({ channelId: MongoIdStringSchema });
export type DeleteTierBody = Static<typeof DeleteTierBodySchema>;

export const DeleteTierParamsSchema = Type.Object({ tierId: MongoIdStringSchema });
export type DeleteTierParams = Static<typeof DeleteTierParamsSchema>;

// =====================================================================================================================
// Publish Tier
// =====================================================================================================================

export const PublishTierParamsSchema = Type.Object({ tierId: Type.String() });
export type PublishTierParams = Static<typeof PublishTierParamsSchema>;

export const PublishTierBodySchema = Type.Object({ channelId: Type.String() });
export type PublishTierBody = Static<typeof PublishTierBodySchema>;

// =====================================================================================================================
// Update Tier
// =====================================================================================================================

export const UpdateTierParamsSchema = Type.Object({ tierId: Type.String() });
export type UpdateTierParams = Static<typeof UpdateTierParamsSchema>;

export const UpdateTierBodySchema = Type.Composite([
  Type.Pick(TierDTOSchema, ['benefits', 'description', 'title', 'amount', 'state']),
  Type.Object({
    channelId: Type.String(),
  }),
]);
export type UpdateTierBody = Static<typeof UpdateTierBodySchema>;
